import script from "./DriversViolationActions.vue?vue&type=script&setup=true&lang=js"
export * from "./DriversViolationActions.vue?vue&type=script&setup=true&lang=js"

import "./DriversViolationActions.vue?vue&type=style&index=0&id=19241f76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19241f76"]])

export default __exports__